export function isNull(value: unknown): boolean {
    return !value || value === '-';
}
